import { Col, Row } from 'antd';
import { Optional } from '../../Shared';
import FatigueViolationDetails from './FatigueViolationDetails';
import type { UserShiftFatigueViolation } from './types';

type ViolationDisplayProps = {
  readonly userShiftFatigueViolation: UserShiftFatigueViolation;
};

/**
 * Displays the user fatigue violation details.
 * All types of fatigue violations are displayed.
 */
const ViolationDisplay = ({
  userShiftFatigueViolation,
}: ViolationDisplayProps) => (
  <>
    <Row gutter={16}>
      <Optional
        show={userShiftFatigueViolation.consecutiveShiftViolations.length > 0}
      >
        <Col span={4}>
          <FatigueViolationDetails
            title="Shifts in consecutive days"
            violations={userShiftFatigueViolation.consecutiveShiftViolations}
          />
        </Col>
      </Optional>
      <Optional
        show={userShiftFatigueViolation.maxShiftHoursViolations.length > 0}
      >
        <Col span={4}>
          <FatigueViolationDetails
            title="Shifts exceeded recommended hours"
            violations={userShiftFatigueViolation.maxShiftHoursViolations}
          />
        </Col>
      </Optional>
      <Optional
        show={userShiftFatigueViolation.shiftRestGapViolations.length > 0}
      >
        <Col span={4}>
          <FatigueViolationDetails
            title="Shifts have not enough rest gap"
            violations={userShiftFatigueViolation.shiftRestGapViolations}
          />
        </Col>
      </Optional>
    </Row>
  </>
);

export default ViolationDisplay;
